MarketReportsApp.Models.MarketReports = Backbone.Model.extend({
	url: function() {
		return '/api/reports/' + MarketReportsApp.Variables.SelectOrganizationId;
	}
});